import React, { useEffect, useState } from 'react';
import { Row, Col, List, message } from 'antd';
import moment from 'moment';
import i18next from 'i18next';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { getNotificationState } from '../../store/notifications/selector';
import { getUserState } from '../../store/user/selector';
import { getOrderState } from '../../store/orders/selector';
import { NotificationProps } from '../../store/notifications/types';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { colors } from '../../constants/colors';
import { arriveTimeDifference } from '../orders/components/CurrentOrders';
import { getScheduleTime } from '../userprofile/components/FoodList';
import { updateReadNotification } from '../../store/notifications/actions';
import { Navbar } from '../layout/Header';

export const warning = () =>
  message.warning(i18next.t('SWITCH_ACCOUNT_MESSAGE'), 1);

export const Notification: React.FC = () => {
  const { notification } = useSelector(getNotificationState);
  const { user } = useSelector(getUserState);
  const { orders } = useSelector(getOrderState);

  const [notificationData, setNotificationData] = useState<
    NotificationProps[]
  >();

  const history: History = useHistory();
  const dispatch = useDispatch();
  const { accountType } = user;
  const isGuest = accountType === 'i seek';
  moment.locale(i18next.language === 'cz' ? 'cs' : i18next.language);

  const checkNotification = () => {
    if (notification) {
      setNotificationData(notification);
    }
  };

  const handleNotifItemPress = (item: NotificationProps) => {
    if (!item.read) {
      dispatch(updateReadNotification(item.id));
    }
    if (item.action === 'placed') {
      if (isGuest) {
        warning();
        return;
      }
      history.push('/orders');
    }

    if (item.action === 'deleted') {
      if (isGuest) {
        warning();
        return;
      }
      history.push('/mymeals');
    }

    if (item.action === 'accepted' || item.action === 'refused') {
      if (!isGuest) {
        warning();
        return;
      }
      const orderNotifItem = orders.find(o => o.id === item.order);
      const ArriveTime =
        orderNotifItem && arriveTimeDifference(orderNotifItem.consumptiondate);
      const getFirstSchedule = _.head(orderNotifItem?.schedule);
      const getFirstScheduleTime = _.head(getFirstSchedule?.time);
      const time = getScheduleTime(getFirstScheduleTime);
      const newmealitems = {
        ...orderNotifItem,
        isOrder: true,
        ArriveTime,
        isGuest,
        time,
      };
      if (orderNotifItem !== undefined) {
        history.push({
          pathname: '/orderdetails',
          state: {
            ...newmealitems,
          },
        });
      } else {
        alert('This meal order has been deleted!');
      }
    }
  };
  useEffect(checkNotification, [notification]);
  console.log(notificationData);
  return (
    <div className="settings-container">
      <Row>
        <Navbar />
      </Row>
      <Row justify="center">
        <Col span={24} className="settings-wrapper">
          <Col
            className="with-padding"
            style={{ paddingBottom: 0, fontSize: 18, fontWeight: 'bold' }}
          >
            {i18next.t('NOTIFICATIONS')}
          </Col>
          <List
            itemLayout="horizontal"
            dataSource={notificationData}
            renderItem={item => {
              const seconds = _.get(item.timeadded, 'seconds');
              const notificationDate = moment.unix(seconds);
              let description = '';
              let title = '';
              switch (item.action) {
                case 'placed':
                  title = i18next.t('NEW_ORDER');
                  description = i18next.t('NEW_ORDER_NOTIFICATION_MESSAGE');
                  break;
                case 'accepted':
                  title = i18next.t('ORDER_ACCEPTED_NOTIFICATION');
                  description = i18next.t('ACCEPTED_ORDER');
                  break;
                case 'refused':
                  title = i18next.t('ORDER_REFUSED_NOTIFICATION');
                  description = i18next.t('REFUSE_MESSAGE');
                  break;
                case 'deleted':
                  title = i18next.t('OFFER_DELETED');
                  description = `${i18next.t('YOUR_OFFER')} "${
                    item.mealname
                  }" ${i18next.t('WAS_DELETED')}`;
                  break;
                default:
                  title = '';
                  description = '';
              }
              return (
                <List.Item
                  style={{
                    backgroundColor: item.read ? colors.white : colors.gray,
                  }}
                >
                  <div
                    className="notification-items"
                    onClick={() => handleNotifItemPress(item)}
                  >
                    <Row justify="space-between" style={{ width: '100%' }}>
                      <List.Item.Meta
                        title={title}
                        description={description}
                        style={{ fontWeight: item.read ? 'normal' : 'bold' }}
                      />
                      <div>{moment(notificationDate).fromNow()}</div>
                    </Row>
                  </div>
                  {item.action === 'deleted' ? (
                    <div style={{ marginLeft: '25px' }}>
                      {i18next.t('Reason')}: {item.reason}
                    </div>
                  ) : null}
                </List.Item>
              );
            }}
          />
        </Col>
      </Row>
    </div>
  );
};
